import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { P } from "../../../../AbstractElements";
import { NoDataFoundPropsType } from "../../../../Type/ContactType";

const NoDataFoundClass = ({ title }: NoDataFoundPropsType) => {
  return (
    <Card className="mb-0">
      <CommonCardHeader title={title} className="d-flex"/>
      <CardBody>
        <P>No Data Found</P>
      </CardBody>
    </Card>
  );
};

export default NoDataFoundClass;
